var exports = {
  "o": "x28a7bf27--7a5f3a--block",
};

module.exports = exports;
